/**
 * RequireRouteAccess - redirects to /dashboard if the user's role is not in
 * the allowedRoles list. Wrap around any <Route> group that should be
 * restricted. Works alongside RequireAuth (auth check comes first).
 *
 * Usage:
 *   <Route element={<RequireRouteAccess allowedRoles={["super_admin","org_admin"]} />}>
 *     <Route path="settings" element={<Settings />} />
 *   </Route>
 */
import { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { AuthContext } from "@/providers/auth-context";

interface Props {
  allowedRoles: string[];
}

export function RequireRouteAccess({ allowedRoles }: Props) {
  const auth = useContext(AuthContext);

  if (auth?.isLoading) return null;

  const role = auth?.user?.role ?? "";

  if (!allowedRoles.includes(role)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
